// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qU0MPAMINUXf6fya5sBw{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
}
  
  

.FeFVn6tfk97znTQKKbki{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
}
.MsPnA6GbbqITxFpuOoX1{
    font-size: 24px;
    font-weight: 600;
}

.JgHMq1Eg_JXiLko2WldL, ._9AcIQm40mCP1ksgKG3FF{
    display: flex;
    flex-direction: column;
    box-sizing: border-box;   

}

.JgHMq1Eg_JXiLko2WldL{
    width: 100%;
    justify-content: left;
    align-items: flex-start;
}

._9AcIQm40mCP1ksgKG3FF{
    justify-content: space-between;
    align-items: center;
    width: 184px;
    height: 80px;
}


.bO1IvYK7fLcGMee8mfj0{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    margin-top: 8px;
    box-sizing: border-box;
    width: 100%;
}

.ItVn4ejkPKGIG57to8IA{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 88px;
    margin:0;
    padding: 0;
    border: 1px solid var(--border-medium);

}
.ss9A09WAKfpwVuxAprHn{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    width: 450px;
    padding: 8px;
    box-sizing: border-box;
}

.zMUurnCh1wM7RpTEuHyw, .g2SoRjx6N3Dy4g8PW1VU, .OrP2MJIk9YnVSWfmxBoi, .O0Licg4_T_75z0uMUz5Q{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px;
    margin-top: 8px;
    box-sizing: border-box;
}

.g2SoRjx6N3Dy4g8PW1VU, .OrP2MJIk9YnVSWfmxBoi, .O0Licg4_T_75z0uMUz5Q{
    height: 32px;
}


.zMUurnCh1wM7RpTEuHyw, .O0Licg4_T_75z0uMUz5Q{
    border: 1px solid var(--border-medium);
    padding: 4px;

}

.g2SoRjx6N3Dy4g8PW1VU, .O0Licg4_T_75z0uMUz5Q{
    background-color: var(--background-dark);
    font-size: 20px;
    font-weight: 600;
    color: var(--letter-light);

}

.g2SoRjx6N3Dy4g8PW1VU{
    border: none
}

.j4eL5z5siNlejDJkd8mz, ._X9vkFAUHGO1I1jNya7w, .UmJQriLCkHhT4YMQr3Z5, .fvbf0DK_J3WYGsndE0Yf, .y5Bp5WtNTesuPr2DLo51, .CwEvhN6El3X1e5KWeWDV,.yOGItcJR3Zo2TzRayGO3, .HhCr6CfiaMAIbpPxDaDp, .QKTsyGxgwwAAyVKmmA3w, .Y0R6FDG1bFo8Gbwin12E, .Fj922S8eP6ccBiSV_V4g, .MbhahoP9LIuBJ6EBJSP5{
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    height: 24px;
    margin-right: 8px;
    box-sizing: border-box;
}   


.MbhahoP9LIuBJ6EBJSP5{
    width: 450px;
}
    
.QKTsyGxgwwAAyVKmmA3w{
    margin-left: 16px;
    width: 450px;
}

.j4eL5z5siNlejDJkd8mz{
    width: 280px;
}
.Fj922S8eP6ccBiSV_V4g{
    width: 105px;
    color: black;
    font-size: 15px;
    font-weight: 100;
}

.yOGItcJR3Zo2TzRayGO3{
    width: 160px;
}

.HhCr6CfiaMAIbpPxDaDp{
    width: 160px;
}

._X9vkFAUHGO1I1jNya7w{
    width: 100px;
}

.Y0R6FDG1bFo8Gbwin12E{
    width: 265px;
}

.UmJQriLCkHhT4YMQr3Z5{
    width: 70px;
    justify-content: center;
    line-break: auto;
    font-size: 14px;
    text-align: center;
}

.fvbf0DK_J3WYGsndE0Yf{
    width: 60px;
    justify-content: center;
    line-break: auto;
    font-size: 14px;
    text-align: center;
}

.y5Bp5WtNTesuPr2DLo51{
    width: 50px;
    justify-content: center;
}

.CwEvhN6El3X1e5KWeWDV{
    width: 60px;
}`, "",{"version":3,"sources":["webpack://./clientRoot/Static/ProvidersPanel/ProvidersPanel.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;;AAE1B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,sCAAsC;;AAE1C;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,sCAAsC;IACtC,YAAY;;AAEhB;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;;AAE9B;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf","sourcesContent":[".providersPanel{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    width: 100%;\n    padding: 16px;\n    box-sizing: border-box;\n}\n  \n  \n\n.providersPanelHeader{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    box-sizing: border-box;\n}\n.providersPanelTitle{\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.providersList, .providersPanelButtons{\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;   \n\n}\n\n.providersList{\n    width: 100%;\n    justify-content: left;\n    align-items: flex-start;\n}\n\n.providersPanelButtons{\n    justify-content: space-between;\n    align-items: center;\n    width: 184px;\n    height: 80px;\n}\n\n\n.providersListMainRow{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height: 32px;\n    margin-top: 8px;\n    box-sizing: border-box;\n    width: 100%;\n}\n\n.edit{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n    width: 100%;\n    height: 88px;\n    margin:0;\n    padding: 0;\n    border: 1px solid var(--border-medium);\n\n}\n.testedNumbersList{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    width: 450px;\n    padding: 8px;\n    box-sizing: border-box;\n}\n\n.provider, .providersListHeader, .editLine, .providersReportHeader{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 16px;\n    margin-top: 8px;\n    box-sizing: border-box;\n}\n\n.providersListHeader, .editLine, .providersReportHeader{\n    height: 32px;\n}\n\n\n.provider, .providersReportHeader{\n    border: 1px solid var(--border-medium);\n    padding: 4px;\n\n}\n\n.providersListHeader, .providersReportHeader{\n    background-color: var(--background-dark);\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--letter-light);\n\n}\n\n.providersListHeader{\n    border: none\n}\n\n.providerName, .affiliateId, .numberOfServiceOrders, .validWhatsapp, .editProvider, .providerStatus,.editingType, .editingDate, .testedNumber, .phoneNumber, .unformattedPhoneNumber, .testedNumbers{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n    height: 24px;\n    margin-right: 8px;\n    box-sizing: border-box;\n}   \n\n\n.testedNumbers{\n    width: 450px;\n}\n    \n.testedNumber{\n    margin-left: 16px;\n    width: 450px;\n}\n\n.providerName{\n    width: 280px;\n}\n.unformattedPhoneNumber{\n    width: 105px;\n    color: black;\n    font-size: 15px;\n    font-weight: 100;\n}\n\n.editingType{\n    width: 160px;\n}\n\n.editingDate{\n    width: 160px;\n}\n\n.affiliateId{\n    width: 100px;\n}\n\n.phoneNumber{\n    width: 265px;\n}\n\n.numberOfServiceOrders{\n    width: 70px;\n    justify-content: center;\n    line-break: auto;\n    font-size: 14px;\n    text-align: center;\n}\n\n.validWhatsapp{\n    width: 60px;\n    justify-content: center;\n    line-break: auto;\n    font-size: 14px;\n    text-align: center;\n}\n\n.editProvider{\n    width: 50px;\n    justify-content: center;\n}\n\n.providerStatus{\n    width: 60px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"providersPanel": `qU0MPAMINUXf6fya5sBw`,
	"providersPanelHeader": `FeFVn6tfk97znTQKKbki`,
	"providersPanelTitle": `MsPnA6GbbqITxFpuOoX1`,
	"providersList": `JgHMq1Eg_JXiLko2WldL`,
	"providersPanelButtons": `_9AcIQm40mCP1ksgKG3FF`,
	"providersListMainRow": `bO1IvYK7fLcGMee8mfj0`,
	"edit": `ItVn4ejkPKGIG57to8IA`,
	"testedNumbersList": `ss9A09WAKfpwVuxAprHn`,
	"provider": `zMUurnCh1wM7RpTEuHyw`,
	"providersListHeader": `g2SoRjx6N3Dy4g8PW1VU`,
	"editLine": `OrP2MJIk9YnVSWfmxBoi`,
	"providersReportHeader": `O0Licg4_T_75z0uMUz5Q`,
	"providerName": `j4eL5z5siNlejDJkd8mz`,
	"affiliateId": `_X9vkFAUHGO1I1jNya7w`,
	"numberOfServiceOrders": `UmJQriLCkHhT4YMQr3Z5`,
	"validWhatsapp": `fvbf0DK_J3WYGsndE0Yf`,
	"editProvider": `y5Bp5WtNTesuPr2DLo51`,
	"providerStatus": `CwEvhN6El3X1e5KWeWDV`,
	"editingType": `yOGItcJR3Zo2TzRayGO3`,
	"editingDate": `HhCr6CfiaMAIbpPxDaDp`,
	"testedNumber": `QKTsyGxgwwAAyVKmmA3w`,
	"phoneNumber": `Y0R6FDG1bFo8Gbwin12E`,
	"unformattedPhoneNumber": `Fj922S8eP6ccBiSV_V4g`,
	"testedNumbers": `MbhahoP9LIuBJ6EBJSP5`
};
export default ___CSS_LOADER_EXPORT___;
